var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative base-input" },
    [
      _c("div", { staticClass: "relative" }, [
        _c("input", {
          ref: _vm.name,
          staticClass:
            "\n       py10 px15 w-100 border-box brdr-1\n       brdr-cl-black h4 sans-serif\n     ",
          class: { pr30: _vm.type === "password", empty: _vm.value === "" },
          attrs: {
            type: _vm.type === "password" ? _vm.passType : _vm.type,
            name: _vm.name,
            maxlength: _vm.name === "apartment-number" && 10,
            autocomplete: _vm.autocomplete,
            autofocus: _vm.autofocus,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled
          },
          domProps: { value: _vm.value },
          on: {
            input: function($event) {
              return _vm.$emit("input", $event.target.value)
            },
            blur: function($event) {
              return _vm.$emit("blur")
            },
            keyup: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.$emit("keyup.enter", $event.target.value)
              },
              function($event) {
                return _vm.$emit("keyup", $event)
              }
            ]
          }
        })
      ]),
      _vm._v(" "),
      _vm.iconActive
        ? _c(
            "button",
            {
              staticClass:
                "\n      icon material-icons absolute brdr-none no-outline\n      p0 bg-cl-transparent cl-brdr-secondary pointer\n    ",
              attrs: {
                type: "button",
                "aria-label": _vm.$t("Toggle password visibility"),
                title: _vm.$t("Toggle password visibility")
              },
              on: {
                click: function($event) {
                  return _vm.togglePassType()
                }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.icon) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.validations
        ? _c("ValidationMessages", { attrs: { validations: _vm.validations } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }